export default function AttachmentIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M11.6685 6.11108L7.22403 10.5555C6.61038 11.1692 6.61038 12.1641 7.22403 12.7778C7.83768 13.3914 8.8326 13.3914 9.44625 12.7778L13.8907 8.3333C15.118 7.106 15.118 5.11616 13.8907 3.88886C12.6634 2.66156 10.6736 2.66156 9.44625 3.88886L5.00181 8.33331C3.16086 10.1743 3.16086 13.159 5.00181 15C6.84276 16.8409 9.82753 16.8409 11.6685 15L16.1129 10.5555"
        stroke="#5E718D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
